import { useState } from 'react'
import { Button, HStack, useToast } from '@chakra-ui/react'
import { pedidosService } from '../services/pedidosService'
import { useUser } from '../../../../../hooks/useUser'

export function ActionButtons({ pedido, onEdit, onSuccess }) {
  const [isApproving, setIsApproving] = useState(false)
  const [isRejecting, setIsRejecting] = useState(false)
  const toast = useToast()
  const { codigo_usuario } = useUser()

  const isPedidoProcessado = pedido.status === 'Aprovado' || pedido.status === 'Reprovado'

  const handleApprove = async () => {
    setIsApproving(true)
    try {
      await pedidosService.confirmarPedido(pedido.id, 'S', codigo_usuario)
      toast({
        title: 'Pedido aprovado',
        description: 'O pedido foi aprovado com sucesso.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      if (onSuccess) onSuccess()
    } catch (error) {
      console.error('Erro ao aprovar pedido:', error)
      toast({
        title: 'Erro ao aprovar pedido',
        description: error.response?.data?.message || 'Ocorreu um erro ao processar sua solicitação.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    } finally {
      setIsApproving(false)
    }
  }

  const handleReject = async () => {
    setIsRejecting(true)
    try {
      await pedidosService.confirmarPedido(pedido.id, 'N', codigo_usuario)
      toast({
        title: 'Pedido recusado',
        description: 'O pedido foi recusado com sucesso.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      if (onSuccess) onSuccess()
    } catch (error) {
      console.error('Erro ao recusar pedido:', error)
      toast({
        title: 'Erro ao recusar pedido',
        description: error.response?.data?.message || 'Ocorreu um erro ao processar sua solicitação.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    } finally {
      setIsRejecting(false)
    }
  }

  return (
    <HStack spacing={2}>
      <Button
        size="sm"
        variant="link"
        colorScheme="green"
        onClick={handleApprove}
        isLoading={isApproving}
        isDisabled={isPedidoProcessado || isRejecting}
      >
        Sim
      </Button>
      <Button
        size="sm"
        variant="link"
        colorScheme="red"
        onClick={handleReject}
        isLoading={isRejecting}
        isDisabled={isPedidoProcessado || isApproving}
      >
        Não
      </Button>
      <Button
        size="sm"
        variant="link"
        colorScheme="blue"
        onClick={() => onEdit(pedido)}
        isDisabled={isPedidoProcessado || isApproving || isRejecting}
      >
        Editar
      </Button>
    </HStack>
  )
}
